import { TranslationKey } from './../../../../types/translation/TranslationKey';
import React from 'react';
import { ProductMasterData } from '../../../../types/product_master_data/productMasterData';
import { TagRelation } from '../../../../types/tag/tagRelation';
import { t } from '../../../../types/translation/Translator';
import { ProductIcon } from '../../../icons/Product/ProductIcon';
import { BaseFilter, BaseFilterProps } from '../common/BaseFilter';
import { FilterStorageKey, FilterProps } from '../common/filter.util';
import { TagFilter } from '../TagFilter';
import { CustomFieldFilter } from '../CustomFieldFilter';
import { CustomField, CustomFieldEntityType } from '../../../../types/custom_field/customField';
import { ProductMasterDataFilter } from '../ProductMasterDataFilter';
import { itemsContainText } from '../../../../util/string.util';
import { HandlingUnit } from '../../../../types/handling_unit/handlingUnit';
import { EntityType } from '../../../../types/comment';
import { Company } from '../../../../types/company';

export class HandlingUnitFilter extends BaseFilter<HandlingUnit> {
  productMasterData: Map<string, ProductMasterData>;
  tagRelations: Map<string, TagRelation>;
  customFields: Map<string, CustomField>;
  company: Company;

  constructor(
    productMasterData: Map<string, ProductMasterData>,
    tagRelations: Map<string, TagRelation>,
    customFields: Map<string, CustomField>,
    company: Company,
  ) {
    super(FilterStorageKey.HANDLING_UNIT);
    this.productMasterData = productMasterData;
    this.tagRelations = tagRelations;
    this.customFields = customFields;
    this.company = company;
  }

  filterOptions = () => [
    new ProductMasterDataFilter(this.customFields, this.tagRelations, this.company),
    new TagFilter(EntityType.pmd),
    ...CustomFieldFilter.for(CustomFieldEntityType.productMasterData, this.productMasterData, this.customFields),
  ];

  toLabel = () => {
    return t(TranslationKey.handlingUnit).singular.label;
  };

  toCount(props: BaseFilterProps) {
    return props.filterProps.product?.size || 0;
  }

  toDropdownContent() {
    return <></>;
  }

  toInnerContent = () => {
    return <></>;
  };

  toIcon = () => {
    return <ProductIcon className={this.className} />;
  };

  search = (item: HandlingUnit, query: string) => {
    const productName = this.productMasterData.get(item.productMasterDataId)?.productName;
    const productNumber = this.productMasterData.get(item.productMasterDataId)?.productNumber;
    return itemsContainText(query, [productName, productNumber]);
  };

  filteredItems(items: HandlingUnit[], query: string, filterProps: FilterProps): HandlingUnit[] {
    return items.filter(item => {
      const pmd = this.productMasterData.get(item.productMasterDataId);

      return [
        ProductMasterDataFilter.filter(filterProps, pmd, this.customFields, this.tagRelations),
        TagFilter.filterBy(filterProps, EntityType.pmd, this.tagRelations, pmd?.id),
        HandlingUnitFilter.filter(filterProps, item, this.customFields),
        this.search(item, query),
      ].every(value => value === null || value);
    });
  }

  static filter(filterProps: FilterProps, item?: HandlingUnit, customFields: Map<string, CustomField> = new Map()) {
    return true;
  }
}
